import React from "react";
import Icon from "@mdi/react";
import { mdiMapMarkerOutline, mdiClockOutline, mdiPhoneOutline, mdiDirections } from "@mdi/js";
import SectionHeading from "./SectionHeading";
import MapEmbed from "./MapEmbed";
import { useSite } from "../theme/ThemeProvider";

const LocationBand = () => {
  const site = useSite();
  const dir = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(site.address.mapsQuery)}`;
  return (
    <section className="section section--surface" id="konum">
      <div className="container">
        <div className="location-band">
          <div className="location-band__text">
            <SectionHeading
              eyebrow="Yeni adresimiz"
              title="Yalova–Kocaeli yolu üzerinde, Kaytazdere'de"
              text="Devlet karayolu üzerindeyiz; Yalova, Altınova, Karamürsel ve Gölcük'ten kolay ulaşım."
            />
            <div className="row">
              <Icon path={mdiMapMarkerOutline} />
              <div>
                <strong>Adres</strong>
                <p>
                  {site.address.line1}
                  <br />
                  {site.address.line2}
                </p>
              </div>
            </div>
            <div className="row">
              <Icon path={mdiClockOutline} />
              <div>
                <strong>Çalışma saatleri</strong>
                {site.hours.map((h) => (
                  <p key={h.days}>
                    {h.days}: {h.time}
                  </p>
                ))}
              </div>
            </div>
            <div className="row">
              <Icon path={mdiPhoneOutline} />
              <div>
                <strong>Telefon</strong>
                <p>
                  <a href={`tel:${site.phoneHref}`}>{site.phone}</a>
                </p>
              </div>
            </div>
            <div>
              <a className="btn btn--outline" href={dir} target="_blank" rel="noreferrer">
                <Icon path={mdiDirections} /> Yol tarifi al
              </a>
            </div>
          </div>
          <MapEmbed />
        </div>
      </div>
    </section>
  );
};

export default LocationBand;
